const config = {
    basename: '/free',
    defaultPath: '/dashboard/default',
    fontFamily: `'serif', sans-serif`,
    borderRadius: 12,
    heavyColor: '#406599',
};

export default config;